import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  spinnerWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
    backgroundColor: designTokens.neutral[50],
    "--colorBrandStroke1": "var(--nh-spinner-accent)",
    "--colorBrandStroke2Contrast": "var(--nh-spinner-ring)",
  },
  loadingSpinner: {
    marginBottom: designTokens.spacing[5],
  },
});
